<template>
  <div>
    <Question
      @answered="changeInput"
      v-for="(question, index) in questions.filter(
        (question) => question.type !== 'association'
      )"
      :key="index"
      :type="question.type"
      :title="question.title"
      :subtitle="question.subtitle"
      :question-id="question.id"
      :index="index"
      :participant-id="participantData.real_id"
      :existing-answer="question.answer"
    />
    <div class="questionnaire-associations">
      <Question
        @answered="changeInput"
        v-for="(question, index) in questions.filter(
          (question) => question.type === 'association'
        )"
        :key="index"
        :type="question.type"
        :title="question.title"
        :subtitle="question.subtitle"
        :question-id="question.id"
        :index="index"
        :participant-id="participantData.real_id"
        :existing-answer="question.answer"
      />
    </div>
  </div>
</template>

<style scoped>
.questionnaire-associations {
  display: flex;
  width: 600px;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>

<script>
import Question from "@/components/question";
import API from "@/api";

export default {
  components: {
    Question,
  },
  data() {
    return {
      questions: [
        // {
        //   type: 'scale',
        //   title: 'Scale question',
        //   subtitle: '1: Totally not agree - 10: Totally agree',
        // },
        // {
        //   type: 'multiple choice',
        //   title: 'Multiple choice question',
        //   options: [
        //       'iPhone', 'Android', 'Other'
        //   ],
        //   multipleAnswers: false,
        //   subtitle: 'Answer the goddamn question',
        //   input: null,
        //   elaboration: ''
        // },
        // {
        //   type: 'yesno',
        //   title: 'Yes / No question',
        //   options: [
        //       'Yes', 'No'
        //   ],
        //   subtitle: 'Whatevah',
        //   input: null,
        //   elaboration: ''
        // },
        // {
        //   type: 'open',
        //   title: 'Open question',
        //   subtitle: 'Whatevah, this is an open question.',
        //   input: null,
        //   elaboration: ''
        // }
      ],
      participantData: null,
    };
  },
  methods: {
    async getParticipant() {
      this.participantData = await API.test.getParticipant(
        this.$route.params.id,
        this.$route.params.participantId
      );
    },
    changeInput(value) {
      const answer = value;
      this.questions[answer.index].input = answer.input;
      this.questions[answer.index].elaboration = answer.elaboration;
    },
    //formatting
    formatQuestions(participantData) {
      participantData.open_questions.forEach((question) => {
        this.questions.push(this.formatOpenQuestion(question));
      });
      participantData.evaluations.forEach(async (question) => {
        this.questions.push(await this.formatEvaluationQuestion(question));
      });
      participantData.associations.forEach((question) => {
        this.questions.push(this.formatAssociationQuestion(question));
      });
    },
    formatOpenQuestion(question) {
      return {
        id: question.id,
        type: "open",
        title: question.text,
        subtitle: null,
        input: null,
        elaboration: "",
        answer: question.answers[0],
      };
    },
    formatAssociationQuestion(question) {
      return {
        id: question.id,
        type: "association",
        title: question.text,
        subtitle: null,
        input: null,
        elaboration: "",
        answer: question.answers[0],
      };
    },
    async formatEvaluationQuestion(question) {
      const meta = await JSON.parse(question.meta);
      return {
        id: question.id,
        type: "scale",
        title: question.text,
        subtitle: `${question.description} ${
          meta ? "1: " + meta[0] + " - 5: " + meta[1] : ""
        }`,
        answer: question.answers[0],
      };
    },
  },
  async mounted() {
    await this.getParticipant();
    this.formatQuestions(this.participantData);
  },
};
</script>
